<template>
  <div class="contaniner">
    <div class="CoalModel_box_title">
      <el-page-header @back="getReturn" content="车辆详情"></el-page-header>
    </div>
    <el-divider></el-divider>
    <div class="car-describe">
      <el-row>
        <el-col :span="5">
          <div>车牌号：{{ carData.carLicensePlateNo }}</div>
        </el-col>
        <el-col :span="5">
          <div>状态：{{ carData.statusDesc }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">
          <div>车辆类型：{{ carData.model }}</div>
        </el-col>
        <el-col :span="10" v-if="carData.status===2&&activities.length">
          <div >自动审核失败原因：<span style="color:red">{{ activities[0].operationRemark }}</span></div>
        </el-col>
      </el-row>
      <div>卸货方式：{{ carData.unloadingWay }}</div>
      <div>绑定司机：{{ carData.bindDriverName }}</div>
      <div v-if="+carData.status == 3">驳回原因:{{ carData.unPassReason }}</div>
    </div>

    <div>行驶证正反面：</div>
    <el-row>
      <el-col :span="10">
        <el-image :src="carData.drivingLicenceFrontImg" :preview-src-list="driverImgList"></el-image>
      </el-col>
      <el-col :span="10">
        <el-image :src="carData.drivingLicenceBackImg" :preview-src-list="driverImgList"></el-image>
      </el-col>
    </el-row>

    <div class="title">道路运输证照片：</div>
    <el-row>
      <el-col :span="10">
        <el-image :src="carData.roadTransportationImg" :preview-src-list="roadList"></el-image>
      </el-col>
      <!-- <el-col :span="10">
              <el-image 
              :src="srcList[0]"
              :preview-src-list="srcList"
            >
          </el-image>
      </el-col>-->
    </el-row>
    <!-- 2,待审核 0,审核成功,3驳回 -->

    <!-- <div v-if="+carData.status == 0"> -->
    <!-- <div>审核通过时间：{{ carData.passTime }}</div>
    <div>操作员：{{ carData.operationUser }}</div> -->
    <!-- </div> -->
    <div style="padding: 10px 40px">
      <span>操作日志:</span>
      <div v-if="activities.length">
        <el-timeline :reverse="reverse" style="padding: 10px">
          <el-timeline-item
            v-for="(activity, index) in activities"
            :key="index"
            :timestamp="activity.operationTime"
          >
            {{ activity.content }}
            <span class="style_mark" @click="handleCheck(activity)" v-if="activity.operationRemark=='修改车辆信息'">查看更变历史</span>
          </el-timeline-item>
        </el-timeline>
      </div>
      <div style="text-indent: 2em" v-else>暂无数据</div>
    </div>
    <div v-if="+carData.status == 2">
      <el-button @click="dialogVisible = true">审核驳回</el-button>
      <el-button type="primary" @click="admCarApproval">审核通过</el-button>
    </div>

    
    <el-dialog
      :visible.sync="dialogVisible"
      title="提示"
      width="40%"
      v-if="dialogVisible"
      :show-close="false"
      :lock-scroll="true"
      :close-on-click-modal="false"
      @close="dialogCloseCallback"
    >
      <el-form :model="rejectForm">
        <span>请选择驳回原因</span>
        <el-form-item label="">
          <el-radio-group v-model="rejectForm.reason" @change="changeReason">
            <el-radio label="行驶证信息错误"></el-radio>
            <el-radio label="道路运输证信息错误"></el-radio>
            <el-radio label="证件信息不清晰"></el-radio>
            <el-radio label="其他">
              其他
              <el-input
                v-model="rejectForm.otherReason"
                size="mini"
                maxlength="10"
                placeholder="请输入原因"
                :disabled="isDisabled"
                clearable
              ></el-input>
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="cancelRej">取消</el-button>
        <el-button type="primary" @click="backApproval">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="更变内容"
      :visible.sync="dialogCheck"
      :before-close="handlecheckClose"
    >
      <div class="dialog_content">
        <div class="dialog_left">
          <div class="list_title">修改前车辆信息</div>
          <el-form :model="formModifyBefore" label-width="80px" label-position="left" size="mini" >
            <el-form-item label="车牌号：" v-if="formModifyBefore.carLicensePlateNo">
              {{formModifyBefore.carLicensePlateNo}}
            </el-form-item>
            <el-form-item label="车辆类型：" v-if="formModifyBefore.model">
              {{formModifyBefore.model}}
            </el-form-item>
            <el-form-item label="卸货方式：" v-if="formModifyBefore.unloadingWay">
              <div>{{formModifyBefore.unloadingWay}}</div>
            </el-form-item>
            <el-form-item label-width="0px" v-if="formModifyBefore.drivingLicenceFrontImg||formModifyBefore.drivingLicenceBackImg">
              <div>行驶证正反面</div>
              <div class="picture_area" v-if="formModifyBefore.drivingLicenceFrontImg">
                <div class="item">
                  <img @click="handlePicture(formModifyBefore.drivingLicenceFrontImg)" :src="formModifyBefore.drivingLicenceFrontImg" alt="">
                </div>
                <div class="item" v-if="formModifyBefore.drivingLicenceBackImg">
                  <img @click="handlePicture(formModifyBefore.drivingLicenceBackImg)" :src="formModifyBefore.drivingLicenceBackImg" alt="">
                </div>
              </div>
            </el-form-item>
            <el-form-item label-width="0px" v-if="formModifyBefore.roadTransportationImg">
              <div>道路运输证</div>
              <div class="picture_area">
                <div class="item">
                  <img @click="handlePicture(formModifyBefore.roadTransportationImg)" :src="formModifyBefore.roadTransportationImg" alt="">
                </div>
                
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="dialog_right">
          <div class="list_title">修改后车辆信息</div>
          <el-form :model="formModifyAfter" label-width="80px" label-position="left" size="mini" >
            <el-form-item label="车牌号" :class="formModifyAfter.carLicensePlateNo === formModifyBefore.carLicensePlateNo?'':'difference'" v-if="formModifyBefore.carLicensePlateNo"> 
              {{formModifyAfter.carLicensePlateNo}}
            </el-form-item>
            <el-form-item label="车辆类型：" :class="formModifyAfter.model === formModifyBefore.model?'':'difference'" v-if="formModifyBefore.model">
              {{formModifyAfter.model}}
            </el-form-item>
            <el-form-item label="卸货方式：" :class="formModifyAfter.unloadingWay === formModifyBefore.unloadingWay?'':'difference'" v-if="formModifyBefore.unloadingWay">
              <div>{{formModifyAfter.unloadingWay}}</div>
            </el-form-item>
            <el-form-item label-width="0px" v-if="formModifyBefore.drivingLicenceFrontImg || formModifyBefore.drivingLicenceBackImg">
              <div>行驶证正反面</div>
              <div class="picture_area" >
                <div class="item" :class="formModifyAfter.drivingLicenceFrontImg === formModifyBefore.drivingLicenceFrontImg?'':'difference'" v-if="formModifyBefore.drivingLicenceFrontImg">
                  <img @click="handlePicture(formModifyAfter.drivingLicenceFrontImg)" :src="formModifyAfter.drivingLicenceFrontImg" alt="">
                </div>
                <div class="item" :class="formModifyAfter.drivingLicenceBackImg === formModifyBefore.drivingLicenceBackImg?'':'difference'" v-if="formModifyBefore.drivingLicenceBackImg">
                  <img @click="handlePicture(formModifyAfter.drivingLicenceBackImg)" :src="formModifyAfter.drivingLicenceBackImg" alt="">
                </div>
              </div>
            </el-form-item>
            <el-form-item label-width="0px" v-if="formModifyBefore.roadTransportationImg">
              <div>道路运输证</div>
              <div class="picture_area">
                <div class="item" :class="formModifyAfter.roadTransportationImg === formModifyBefore.roadTransportationImg?'':'difference'">
                  <img @click="handlePicture(formModifyAfter.roadTransportationImg)" :src="formModifyAfter.roadTransportationImg" alt="">
                </div>
                
              </div>
            </el-form-item>
          </el-form>
        </div>
        <el-dialog
          key="1"
          :visible.sync="dialogPicture"
          width="40%"
          append-to-body
        >
          <span class="show_picture">
            <img :src="showPicture" alt="">
          </span>
        </el-dialog>
      </div>
    </el-dialog>
  </div>
  <!--操作影响弹窗-->
</template>

<script>
// ENABLE(0, "启用"),
//     DISABLE(1, "停用"),
//     PENDING_APPROVAL(2, "待审核"),
//     REJECT(3, "驳回"),
export default {
  props: {
    carLicensePlateNo: {
      type: [String],
      default: 100
    },
    carId: {
      type: [Number],
      default: 0
    }
  },
  data() {
    return {
      dialogVisible: false,
      driverImgList: [],
      roadList: [],
      loading: false,
      carData: {},
      rejectForm: {
        reason: [],
        otherReason: "",
      },
      activities:[],
      reverse:false,
      isDisabled:true,
      dialogCheck: false,
      dialogPicture: false,
      showPicture: '',
      formModifyBefore: {},
      formModifyAfter: {}
    };
  },
   mounted() {
   this.getDetail();
    this.getLogList()
  },
  methods: {
    getDetail() {
      const _t = this;
      _t.$api.carModel
        .admCarDetail({
          carLicensePlateNo: _t.carLicensePlateNo,
          id: _t.carId
        })
        .then(res => {
          if (res.code === "0") {
            _t.driverImgList.push(res.data.drivingLicenceFrontImg);
            _t.driverImgList.push(res.data.drivingLicenceBackImg);
            _t.roadList.push(res.data.roadTransportationImg);
            _t.carData = res.data;
            _t.loading = false;
          } else {
            _t.loading = false;
            _t.$message({
              message: "查询失败, " + res.message,
              type: "error"
            });
          }
        });
    },
    getLogList(){
      let params = {
        pageNo: 1,
        pageSize: 100,
        operationModule: 9,
        operationType: 2,
      };
      params["searchFieldList[0].fieldName"] = "dataPk";
      params["searchFieldList[0].singleValue"] = this.carLicensePlateNo;
      this.$api.carModel.getLogList(params).then((res) => {
          this.activities = res.data.dtoList || []
          this.activities.forEach(item=>{
            item.content = ''
            if(item.operationRemark == '道路运输证识别失败' || item.operationRemark =='行驶证与道路运输证车牌号不符'){item.content='自动审核未通过,原因：'}
            if(item.operationType =='审核驳回') item.content +=  item.operationType+'，'
            item.content +=item.operationType =='审核驳回' ? '驳回原因：'+  item.operationRemark : item.operationRemark
            if(item.operationStaffName) item.content +='，操作人：' + item.operationStaffName
          })
      })
    },
    cancelRej(){
      this.dialogVisible =false
      this.dialogCloseCallback()
    },
    dialogCloseCallback(){
      this.rejectForm.reason = []
      this.rejectForm.otherReason =''
      console.log(this.rejectForm);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    getReturn() {
      this.$emit("detailFun", false);
    },
    //审核
    admCarApproval(val) {
      const _t = this;
      _t.$confirm("请仔细检查车辆信息，是否确认通过?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(() => {
          _t.$api.carModel
            .admCarApproval({
              id: _t.carId,
              carLicensePlateNo: this.carLicensePlateNo,
              approvalResult: 0,
              approvalRemark: "审核通过"
            })
            .then(res => {
              if (res.code === "0") {
                _t.$message({
                  message: "审核成功!",
                  type: "success"
                });
                _t.getDetail();
                _t.getLogList()
              }
            });
        })
        .catch(() => {});
    },
    changeReason(val) {
      console.log(val, val.includes("其他"));
      if (!val.length) return;
      this.isDisabled = val.includes("其他") ? false : true;
      if (!val.includes("其他")) {
        this.rejectForm.otherReason = "";
      }
    },
    // 驳回
    backApproval() {
      let { reason, otherReason } = this.rejectForm;
      if (!reason.length) {
        this.$message({
          type: "error",
          message: "请选择原因",
          offset: 300,
        });
        return;
      }
      if (reason.includes("其他") && otherReason == "") {
        this.$message({
          type: "error",
          message: "请填写原因",
          offset: 300,
        });
        return;
      }
      let approvalRemark = reason.replace("其他", otherReason);
      const _t = this;
      _t.$api.carModel
        .admCarApproval({
          id: _t.carId,
          carLicensePlateNo: this.carLicensePlateNo,
          approvalResult: 1,
          approvalRemark,
        })
        .then(res => {
          if (res.code === "0") {
            _t.dialogVisible = false;
            _t.dialogCloseCallback()
            _t.$message({
              message: "驳回成功!",
              type: "success"
            });
            _t.getDetail();
            _t.getLogList()
          }
        });
    },
    handleCheck(data){
      const beforeList = JSON.parse(data.modifyBeforeJson)
      const afterist = JSON.parse(data.modifyAfterJson)
      for(let i = 0; i< beforeList.length;i++){
        const item = beforeList[i]
        this.formModifyBefore[item.name] = item.value
      }
      for(let i = 0; i< afterist.length;i++){
        const item = afterist[i]
        this.formModifyAfter[item.name] = item.value
      }
      this.dialogCheck = true
    },
    handlecheckClose(){
      this.dialogCheck = false
      this.formModifyBefore = {}
      this.formModifyAfter ={}
    },
    handlePicture(src){
      console.log(12312312)
      this.showPicture = src
      this.dialogPicture = true
    }
  }
};
</script>

<style lang="scss" scoped>
.el-image {
  width: 400px;
  height: 300px;
  margin-right: 20px;
  margin-top: 20px;
}
.title {
  margin-top: 40px;
}
.el-select {
  margin-right: 30px;
}
.el-table {
  width: 80%;
}
.contaniner {
  padding-bottom: 100px;
  font-size: 14px;
}
.el-button {
  margin-left: 40px;
  margin-top: 40px;
}

.style_mark{
  color: rgb(64, 158, 255);
  text-decoration: underline;
  cursor: pointer;
}
.dialog_content{
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  ::v-deep .el-form-item {
    margin-bottom: 0px;
  } 
  .dialog_right{
    flex: 1;
    border-left: #606060 1px solid;
    padding-left: 20px;
  }
  .dialog_left{
    flex: 1;
    padding-left: 20px;
  }
  .list_title{
    font-size: 16px;
    color: #000;
    margin-bottom: 10px;
  }
}
::v-deep .el-form-item__content {
  font-size: 12px;
}
::v-deep .el-form-item__label{
  font-size: 12px;
}
.picture_area{
  display: flex;
  flex-direction: row;
  .item{
    margin-right: 5px;
    cursor: pointer;
  }
  img{
    width: 100px;
    height: 100px;
  }
}
.difference{
  color: red;
  img{
    border:red solid 1px;
  }
}
.show_picture{
  img{
    width: 100%;
  }
}
</style>